import * as React from 'react';

import s from './ProgressBar.module.css';

export const ProgressBar = React.memo<React.ComponentPropsWithoutRef<'progress'>>((props) => {
  return <progress className={s.root} {...props} />;
});

ProgressBar.displayName = 'ProgressBar';
